import { Box, Typography } from "@mui/material";
import { TooltipProps } from "recharts";
import { FormatMoney } from "src/shared/Utils/FormatMoney";

export const CustomTooltipProfit = ({
  active,
  payload,
  label,
}: TooltipProps<number, string>) => {
  if (!active || !payload?.length) return null;

  const value = payload[0].value ?? 0;
  const isNegative = value < 0;
  const color = isNegative ? "#EF4444" : "#4361EE";
  const formattedValue = FormatMoney(String(Math.abs(value).toFixed(2)));

  return (
    <Box
      sx={{
        background: "#fff",
        border: "1px solid #E5E7EB",
        borderRadius: "10px",
        padding: "10px 14px",
        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
        minWidth: 160,
      }}
    >
      <Typography
        sx={{ fontSize: "0.75rem", color: "#9CA3AF", mb: 0.5, fontWeight: 500 }}
      >
        {label}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: color,
          }}
        />
        <Typography sx={{ fontSize: "0.8rem", color: "#374151" }}>
          Lucro
        </Typography>
        <Typography
          sx={{ fontSize: "0.85rem", fontWeight: 700, color, ml: "auto" }}
        >
          {isNegative ? "- " : ""}R$ {formattedValue}
        </Typography>
      </Box>
    </Box>
  );
};
